
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ask",
      function () {
        return require("private-next-pages/ask/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ask"])
      });
    }
  